import { useCallback } from "react";
import useStorageState from "./useStorageState";

export interface RecentCustomer {
  id: string;
  account: string;
  name: string | null;
  address: string | null;
}

const MAX_RECENT = 10;

// Per device and per org: a convenience list, nothing depends on it.
export function useRecentCustomers(orgSegment: string) {
  const [recent, setRecent] = useStorageState<RecentCustomer[]>(
    `recent-customers:${orgSegment}`,
    [],
  );

  const remember = useCallback(
    (customer: RecentCustomer) => {
      setRecent([
        customer,
        ...recent.filter((c) => c.id !== customer.id),
      ].slice(0, MAX_RECENT));
    },
    [recent, setRecent],
  );

  return { recent, remember };
}
